module.exports = __webpack_public_path__ + "img/grabpay.1dd7467.png";